import React from "react";
import { Box, Breadcrumbs, Link } from "@mui/material";
import colors from "../themes/colors";
import { dt } from "../themes/redesignTokens";

export interface BreadcrumbItem {
  title?: string;
  link?: string;
}

export interface PageBreadcrumbsProps {
  items?: BreadcrumbItem[];
}

const PageBreadcrumbs = ({ items }: PageBreadcrumbsProps) => {
  return (
    <Breadcrumbs sx={{ fontSize: "20px", fontWeight: 500, color: colors.secondary.gray20 }}>
      {items?.map((item, i) => !!item.link ? (
        <Link
          key={`page-breadcrumb-item-${i}`}
          href={item.link}
          sx={{ textDecoration: "none", color: dt.blue }}
        >
          {item.title}
        </Link>
      ) : (
        <Box key={`page-breadcrumb-item-${i}`}>{item.title}</Box>
      ))}
    </Breadcrumbs>
  );
};

export default PageBreadcrumbs;
